import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { kebabCase, indexOf, reduce, each } from 'lodash';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';
import {
  getPrograms, getProgramLoading, getProgramLoaded,
  supportPrograms,
} from '../../NominationReducer';
import styles from './styles.css';

export function getAvailablePrograms(programs) {
  const validPrograms = ['Voice of the Buyer', 'Win Loss', 'Customer Experience']; // for now
  return reduce(supportPrograms, (allPrograms, supportProgram) => {
    if (indexOf(validPrograms, supportProgram.value) >= 0) {
      const sl = kebabCase(supportProgram.value);
      const isVOB = supportProgram.value === 'Voice of the Buyer';
      const subTypes = isVOB ? ['opportunities', 'accounts'] : [null];

      each(subTypes, (subType) => {
        let isAccounts = false;
        if (isVOB) {
          if (subType === 'accounts') {
            isAccounts = true;
          } else if (subType === 'opportunities') {
            isAccounts = false;
          }
        } else if (sl === 'win-loss') {
          isAccounts = false;
        } else if (sl === 'customer-experience') {
          isAccounts = true;
        }
        const items = programs[supportProgram.value];
        if (items && items.length > 0) {
          each(items, (item) => {
            const name = subType ? (<span>{item.name} <span className="badge">{subType}</span></span>) : item.name;
            const path = subType ? `/nominations/${sl}/:programID/${subType}` : `/nominations/${sl}/:programID`;
            const programId = item.program_id;
            const url = path.replace('/:programID', `/${programId}`);
            const slug = subType ? `${sl}/${subType}` : sl;
            const childLabel = isAccounts ? 'Accounts' : 'Opportunities';

            allPrograms.push({
              id: `${item.client_id}|${programId}|${subType}`,
              name,
              slug,
              program_id: programId,
              type_name: item.type_name,
              type_value: item.type_value,
              path,
              url,
              children: [
                {
                  path, label: childLabel, type: 'table', url,
                },
                {
                  path: `${path}/saved`, label: 'Saved', type: 'saved', url: `${url}/saved`,
                },
                {
                  path: `${path}/unlinked-contacts`, label: 'Unlinked', type: 'unlinked', url: `${url}/unlinked-contacts`,
                },
              ],
            });
          });
        }
      });
    }
    return allPrograms;
  }, []);
}

class NominationNav extends Component {
  renderType(type) {
    let l = type;
    if (type === 'Win Loss') {
      l = 'wl';
    } else if (type === 'Customer Experience') {
      l = 'ce';
    } else if (type === 'Voice of the Buyer') {
      l = 'vb';
    }
    return (<span className={`${styles.type} ${styles[l]}`}>{l}</span>);
  }

  render() {
    const { loading, loaded, programs } = this.props;
    if (loading || !loaded) {
      return null;
    }
    const availablePrograms = getAvailablePrograms(programs);
    if (availablePrograms.length === 0) {
      return null;
    }
    return (
      <ul className="nav nav-tabs">
        {availablePrograms.map(program => (
          <LinkContainer key={program.id} to={program.url}>
            <NavItem>
              {this.renderType(program.type_name)}
              {program.name}
            </NavItem>
          </LinkContainer>
        ))}
      </ul>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    programs: getPrograms(state),
    loading: getProgramLoading(state),
    loaded: getProgramLoaded(state),
  };
}

NominationNav.propTypes = {
  programs: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
};

NominationNav.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(NominationNav);
